var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"futurelayer-gallery-image-wrapper",style:(_vm.cssStyleForWrapper)},[_c('div',{staticClass:"futurelayer-gallery-image-outline",style:(_vm.cssStyleForOutline)})])
}
var staticRenderFns = []

export { render, staticRenderFns }